import { Icon, type IconName } from './Icon';

export interface TabItem {
  label: string;
  href: string;
  active: boolean;
  icon?: IconName;
  badge?: string;
  title?: string;
}

export function Tabs({ items }: { items: TabItem[] }) {
  return (
    <nav class="tabs" role="tablist">
      {items.map((t) => (
        <a key={t.href} role="tab" class={`tab ${t.active ? 'active' : ''}`} href={t.href} aria-selected={t.active} title={t.title}>
          {t.icon && <Icon name={t.icon} size={15} />}
          {t.label}
          {t.badge && <span class="badge badge-muted">{t.badge}</span>}
        </a>
      ))}
    </nav>
  );
}

/** In-page sub tabs (not routed). */
export function SubTabs<T extends string>({ items, value, onChange }: { items: Array<{ key: T; label: string; count?: number }>; value: T; onChange: (k: T) => void }) {
  return (
    <div class="subtabs" role="tablist">
      {items.map((it) => (
        <button key={it.key} type="button" role="tab" class={`subtab ${it.key === value ? 'active' : ''}`} aria-selected={it.key === value} onClick={() => onChange(it.key)}>
          {it.label}
          {it.count !== undefined && <span class="muted"> {it.count}</span>}
        </button>
      ))}
    </div>
  );
}
